const env = process.env.REACT_APP_NODE_ENV as "stg" | "prod";

console.log("REACT_APP_NODE_ENV from process.env:", process.env.REACT_APP_NODE_ENV);
console.log("env after cast:", env);

const urls = {
  stg: "https://pw34zau3j2.execute-api.eu-central-1.amazonaws.com/dev",
  prod: "https://ro3njl1s7h.execute-api.eu-central-1.amazonaws.com/prod",
};

// Amélioration de la logique de sélection d'URL avec plus de logs
let selectedUrl: string;
if (env === "prod") {
  selectedUrl = urls.prod;
  console.log("Using PROD environment");
} else if (env === "stg") {
  selectedUrl = urls.stg;
  console.log("Using STG environment");
} else {
  selectedUrl = urls.stg;
  console.warn("Environment not recognized, falling back to STG. Received env:", env);
}

console.log("Selected API URL:", selectedUrl);

export const apiCampaginUrl = selectedUrl;
